import { Box, Link as MuiLink } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { forgotPassword } from "actions/user";
import { FormKit } from "components/forms/FormKit";
import { Notification } from "components/layout/notifications/Notification";
import { T } from "components/util/t";

const fields = [
    {
        name: "email",
        type: "text",
        label: "Email:",
        required: true,
    },
];

export const ForgotPasswordForm = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [error, setError] = useState<string>();
    const [message, setMessage] = useState<string>();

    const handleSubmit = async ({ email }: { email: string }) => {
        return forgotPassword(email)(dispatch)
            .then(() => {
                setError(undefined);
                setMessage(
                    "An email has been sent with instructions on how to reset your password.",
                );
            })
            .catch((e) => {
                setError(
                    e.response?.status === 422
                        ? "Uh oh. That email address does not have a Liveheats account yet."
                        : "Oops, something went wrong!",
                );
                setMessage(undefined);
            });
    };

    return (
        <>
            {message && (
                <Notification
                    type="success"
                    className="margin-bottom"
                    text={message}
                />
            )}
            {error && (
                <Notification
                    type="warning"
                    className="margin-bottom"
                    text={error}
                />
            )}
            <FormKit
                initialValues={{ email: "" }}
                fields={fields}
                onSubmit={handleSubmit}
                classNames={{ buttons: "actions", button: "loading-button" }}
                buttonLabel="Get reset link"
            />
            <Box className="actions change-page-action">
                <MuiLink
                    to={{
                        pathname: "/login",
                        state: location.state,
                    }}
                    component={Link}
                >
                    <T>Log in</T>
                </MuiLink>
            </Box>
        </>
    );
};
